<template>
	<b-modal ref="modal" size="lg" hide-footer>
        <template v-slot:modal-title>
            {{ $t('action.export_global') }}
        </template>

        <LoadingSpinner v-if="loading" />
        <div v-else>
        	<div class="row mb-2">
        		<div class="col">
        			<template v-if="export_ask_date">{{ $t('monte.export.export_date') }} {{ export_ask_date }} {{ $t('global.a') }} {{ export_ask_time }}</template>
        		</div>
        		<div class="col-auto ml-auto">
        			<b-button v-if="!export_ask_date" variant="primary" @click="askExport">{{ $t('monte.export.ask') }}<font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" spin /></b-button>
        			<b-button variant="primary" class="ml-1" @click="newExport">{{ $t('monte.export.new_export') }}<font-awesome-icon v-if="processing_new" :icon="['fal', 'spinner']" spin /></b-button>
        		</div>
        	</div>
        	<b-table
				striped hover
				:items="exports"
				:fields="columns"
			>
				<template v-slot:cell(download)="data">
					<a href='#' @click.prevent="downloadFile(data.item.filename)"><font-awesome-icon v-if="data.item.loading" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['fas','download']" /></a>
				</template>
			</b-table>
        </div>
	</b-modal>
</template>

<script type="text/javascript">
	import ContractMixin from "@/mixins/Contract.js"

	export default {
		name: 'ModalExportGlobal',
		mixins: [ContractMixin],
		props: ['season_id'],
		data () {
			return {
				loading: false,
				exports: [],
				processing: false,
				processing_new: false,
				export_ask_date: null,
				export_ask_time: null,
				columns: [
					{
						key:'filename', 
						label: this.getTrad('monte.export.filename')
					},
					{
						key:'date',
						label: this.getTrad('monte.export.date')
					},
					{
						key:'download',
						label: this.getTrad('monte.export.download')
					}
				],
			}
		},

		methods: {
			async openModal() {
                this.$refs.modal.show()
                this.loading = true
                
                const res = await this.loadExportGlobalSeason(this.season_id)
                this.exports = res.all_exports.map(e => ({...e, date: this.formatDate(e.date), loading: false}))

                this.export_ask_date = null 
				this.export_ask_time = null 
                if(res.export_ask_date) {
	                this.export_ask_date = this.formatDate(res.export_ask_date)
	                const time = new Date(res.export_ask_date)
	                this.export_ask_time = time.getHours()+':'+time.getMinutes()
	            }
                this.loading = false
			},

			async downloadFile(filename) {
				const index = this.exports.findIndex(e => e.filename == filename)
				this.exports[index].loading = true
                await this.downloadExportGlobal(this.season_id, filename)
				this.exports[index].loading = false
			},

			async askExport() {
				this.processing = true
                await this.askExportSeason(this.season_id)
                this.successToast('monte.export.asked')
				this.processing = false
				this.openModal()
			},

			async newExport() {
				this.processing_new = true
                await this.downloadNewExportGlobal(this.season_id)
				this.processing_new = false
			}
		},

		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>